import { PayorAccountType } from '../enums';

export function normaliseSourceAccount({ accountType, ...account }) {
  // accountType is kept for legacy reasons
  const type = account.type || accountType || PayorAccountType.FBO;
  return { ...account, type };
}
